// extracted by mini-css-extract-plugin
export var buttonContainer = "_8c-1";
export var fontSizeSelect = "_8c-3";
export var formatSelect = "_8c-2";
export var formats = "_8c-4";
export var hidden = "_8c-5";
export var icon = "_8c-6";
export var select = "_8c-0";